import {Back, NextQuestion, SessionId} from 'symptom_checker_api';
import router from '../../router';
import {apiInstance} from "../../api/felcana_api";


const state = () => ({
    session_id: null,
    answer: null,
    question: null,
    summary: null
})

const mutations = {
    save(state, value) {
        state[value.key] = value.value
    },

    begin(state, question) {
        state.question = question;
        state.session_id = question.session_id;
        console.log(`session_id: ${question.session_id}`);
    },

    next(state, question) {
        state.question = question;
        state.session_id = question.session_id;
    }
}

const actions = {
    begin({commit}) {
        apiInstance.apiV1ScBeginCreate().then(function (res) {
            console.info("Store Action: Begin: ", res)
                commit('begin', res);
            }, function (error) {
                console.error(error);
            }
        ).catch(error => console.error(error))
    },

    next({commit, getters}, answer) {
        let nq = new NextQuestion(getters.session_id, answer.answer);
        apiInstance.apiV1ScNextCreate(nq).then(function (res) {
            if (res.terminated === true) {
                console.log("jumping to pre-summary")
                router.push({name: process.env.VUE_APP_DASHBOARD_PRE_SUMMARY}).then(r => {
                    console.log(r)
                });
            } else {
                commit('next', res);
                if (router.currentRoute.name !== process.env.VUE_APP_SYMPTOM_CHECKER_NEXT) {
                    router.push({name: process.env.VUE_APP_SYMPTOM_CHECKER_NEXT});
                }
            }
        }, function (error) {
            console.log(error);
        }).catch(error => console.error(error))
    },
    back({commit, getters}) {
        let nq = new Back(getters.session_id)
        apiInstance.apiV1ScBackCreate(nq).then(function (res) {
            commit('next', res);
            let test1 = router.currentRoute.name
            let test2 = process.env.VUE_APP_SYMPTOM_CHECKER_NEXT
            if (router.currentRoute.name !== process.env.VUE_APP_SYMPTOM_CHECKER_NEXT || res.start) {
                router.back();
            }

            console.log(res);
        }, function (error) {
            console.log(error)
        }).catch(error => console.log(error))
    },
    presummary({commit, getters}) {
        console.log("pre-summary");
        if (router.currentRoute.name === process.env.VUE_APP_SYMPTOM_CHECKER_SUMMARY) {
            router.back();
        }
    },
    async summary({commit, getters}) {
        let nq = new SessionId(getters.session_id);
        apiInstance.apiV1ScSummaryCreate(nq).then((res) => {
            commit('save', {
                key: 'summary',
                value: res
            })
        })
    }
}

const getters = {
    validSession: state => !!state.session_id,
    session_id: state => state.session_id,
    question: state => state.question,
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}